<div class="mt-3">
  <label>Observações</label>
  <textarea
    class="form-control"
    data-cy="annotation"
    rows="5"
    maxlength="1000"
    name="annotation"
    [(ngModel)]="annotation"
    [disabled]="annotationIsDisabled"
  >
  </textarea>
  <span class="text-right" *ngIf="annotation != null"
    >{{ annotation.length }}/1000 caracteres</span
  ><br />
</div>
